import React from "react";
import Property1Frame271 from "../Property1Frame271";
import "./Property1Frame272.css";

function Property1Frame272(props) {
  const {
    bridalLook,
    rectangle321,
    party,
    fashion,
    surname,
    rectangle14,
    rectangle33,
    rectangle322,
    property1Frame271Props,
  } = props;

  return (
    <div className="hero-section">
      <div className="frame-270-1">
        <Property1Frame271 {...property1Frame271Props} />
      </div>
      <div className="overlap-group1">
        <div className="looks poppins-medium-black-12px">
          <div className="bridal-look">{bridalLook}</div>
          <div className="flex-col">
            <img className="rectangle-32" src={rectangle321} />
            <div className="party poppins-medium-black-12px">{party}</div>
          </div>
          <div className="fashion">{fashion}</div>
          <div className="surname">{surname}</div>
        </div>
        <img className="rectangle-14" src={rectangle14} />
        <img className="rectangle-33" src={rectangle33} />
        <div className="rectangle-45 border-1px-tundora"></div>
        <img className="rectangle-32-1" src={rectangle322} />
      </div>
    </div>
  );
}

export default Property1Frame272;
